import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHogInstance } from 'shared/posthogCapture/types';

interface NoResultsProperties {
  query_length: number;
}

export const createEventsSearchCaptureEvents = (posthog: PostHogInstance) => ({
  opened: () => {
    posthog?.capture('events / search / opened');
  },
  closed: () => {
    posthog?.capture('events / search / closed');
  },
  noResults: (properties: NoResultsProperties) => {
    posthog?.capture('events / search / no results', properties);
  },
  eventSelected: () => {
    posthog?.capture('events / search / event / selected');
  },
  noteSelected: () => {
    posthog?.capture('events / search / note / selected');
  },
});

export type EventsSearchCaptureEvents = ReturnType<
  typeof createEventsSearchCaptureEvents
>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  return useMemo(() => createEventsSearchCaptureEvents(posthog), [posthog]);
};
